import styled from 'styled-components'

export const EventCard = styled.main`
    width: min(100%, 920px);
    box-sizing: border-box;
    padding: clamp(26px, 5vw, 52px);
    border: 1px solid ${p => p.theme.palette.colors.borderSoft};
    border-radius: 28px;
    background: linear-gradient(145deg, ${p => p.theme.palette.colors.surfaceElevated} 0%, ${p => p.theme.palette.colors.surfaceElevatedStrong} 100%);
    box-shadow: 0 28px 70px ${p => p.theme.palette.colors.shadowStrong};
`

export const EventEyebrow = styled.p`
    margin: 0 0 12px;
    color: ${p => p.theme.palette.blue.main};
    font-family: Poppins;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
`

export const EventTitle = styled.h1`
    margin: 0;
    color: ${p => p.theme.palette.colors.text};
    font-family: Gilroy;
    font-size: clamp(32px, 5vw, 50px);
    font-weight: 700;
    line-height: 1.05;
`

export const EventLead = styled.p`
    max-width: 650px;
    margin: 18px 0 0;
    color: ${p => p.theme.palette.colors.muted};
    font-family: Lato;
    font-size: 18px;
    line-height: 1.55;
`

export const FormIntro = styled.p`
    margin: 36px 0 0;
    color: ${p => p.theme.palette.colors.text};
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
`

export const FormFooter = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 8px;
`

export const PrivacyLink = styled.p`
    margin: 4px 0 0;
    color: ${p => p.theme.palette.colors.subdued};
    font-family: Lato;
    font-size: 13px;
    line-height: 1.5;
`
